/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import React from "react";
import { AuthorizationService } from "../../../service/AuthorizationService";
import { User } from "../../../types/mainTypes";
import SpecialInitiativeSummaryAnalysis from "../deals/SummaryAnalysis/SpecialInitiativeSummaryAnalysis";
import SpecialInitiativeDealsListing from "./SpecialInitiativeDealsListing";

type Props = {
    user?: User;
    article;
    sort;
    authorizationService?: AuthorizationService;
};

type State = {
    tab: string;
};
class SpecialInitiativeDeals extends React.Component<Props, State> {
    summaryTab: boolean;
    constructor(props) {
        super(props);

        this.summaryTab = true;

        this.state = {
            tab: this.summaryTab ? "summary" : "table"
        };
    }

    onClick = (event) => {
        event.preventDefault();
        this.setState((prev) => ({
            tab: prev.tab === "summary" ? "table" : "summary"
        }));
    };

    render() {
        const { article, sort } = this.props;

        return (
            <div className={"row mt-4"}>
                <div className={"col-md-12"}>
                    <div>
                        <div className="row">
                            <div className="col-md-3 order-md-2">
                                <img
                                    src={article.image}
                                    className={"logo"}
                                    width="250"
                                />
                            </div>
                            <div className="col-md-9 order-md-1">
                                <div className={"pl-3 pt-3 pb-3"}>
                                    The COP 26 Blended Finance platform is the
                                    only dedicated pipeline of fundraising
                                    climate-focused blended finance deals. To be
                                    eligible, deals must:
                                    <ul>
                                        <li>
                                            a. Have a blended finance 
                                            <a href="https://convergence.finance/blended-finance">
                                                structure
                                            </a>
                                            ,
                                        </li>
                                        <li>
                                            b. Have confirmed third party
                                            interest and/or be on track to reach
                                            financial close at or shortly
                                            following COP26.
                                        </li>
                                        <li>
                                            c. Have a minimum total deal size of
                                            $100 million, and
                                        </li>
                                        <li>
                                            d. Target at least one of the
                                            climate related Sustainable
                                            Development Goal in a developing
                                            country(ies).
                                        </li>
                                    </ul>
                                    If you are sponsoring, advising, or
                                    investing in a climate focused blended
                                    finance transaction that you'd like to have
                                    featured on the COP 26 Blended Finance
                                    Platform, please contact{" "}
                                    <a href="mailto:safia.gulamani@convergence.finance">
                                        Safia Gulamani
                                    </a>{" "}
                                    or{" "}
                                    <a href="mailto:chris.clubb@convergence.finance">
                                        Chris Clubb.
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul className="nav nav-pills">
                        {this.summaryTab && (
                            <li
                                className={
                                    this.state.tab === "summary"
                                        ? "nav-item border border-primary"
                                        : "nav-item border border-primary"
                                }
                            >
                                <a
                                    className={
                                        this.state.tab === "summary"
                                            ? "nav-link active"
                                            : "nav-link"
                                    }
                                    href={"#"}
                                    onClick={this.onClick}
                                >
                                    Summary Analysis
                                </a>
                            </li>
                        )}
                        <li
                            className={
                                this.state.tab === "table"
                                    ? "nav-item border border-primary"
                                    : "nav-item border border-primary"
                            }
                        >
                            <a
                                className={
                                    this.state.tab === "table"
                                        ? "nav-link active"
                                        : "nav-link"
                                }
                                href={"#"}
                                onClick={this.onClick}
                            >
                                Transactions
                            </a>
                        </li>
                    </ul>
                    <div>
                        {this.state.tab === "summary" ? (
                            <SpecialInitiativeSummaryAnalysis
                                initiative={article.tags}
                            />
                        ) : (
                            <SpecialInitiativeDealsListing
                                user={this.props.user}
                                authorizationService={
                                    this.props.authorizationService
                                }
                                sort={sort}
                                initiative={article.tags}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default SpecialInitiativeDeals;
